import React from 'react';

export const SelectedActivities = ({ selectedActivities = [], onRemoveActivity }) => {
  if (!Array.isArray(selectedActivities)) {
    console.error('Selected activities is not an array:', selectedActivities);
    return (
      <div className="text-center text-gray-500">
        Error loading selected activities.
      </div>
    );
  }

  if (selectedActivities.length === 0) {
    return (
      <div className="text-gray-500">
        No activities selected yet
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {selectedActivities.map((activity) => (
        <div
          key={activity.name}
          className="bg-white rounded-lg shadow-md p-4 flex justify-between items-center"
        >
          <div>
            <h3 className="text-lg font-semibold">{activity.name}</h3>
            <div className="flex flex-wrap gap-2 mt-2">
              {(activity.skillTags || []).map((tag, index) => (
                <span
                  key={index}
                  className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <button
            onClick={() => onRemoveActivity(activity.name)}
            className="text-red-600 hover:text-red-800"
            title="Remove activity"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}; 